module.exports = "/_next/static/images/palash-7222c56d7497c3337d4355b155c43553.png";